import * as React from 'react';
import * as moment from 'moment';
import {
    FormListener,
    Form,
} from '../../../form/Form';
import {
    ListView,
    createInitialState,
} from '../../ListView';
import {
    HistoricTournamentListRequest,
    HistoricTournament,
    ListRequest,
} from '../../../../../generated/protocol';
import {
    TournamentHistoryService,
    TournamentRefundResponse,
    CalculatedTournamentRefundResponse,
    PlayerRefund
} from '../../../../service/poker/history/TournamentHistoryService';
import { Symbols} from '../../../../ioc/Symbols';
import { kernel} from '../../../../ioc/IOCHelper';
import {
    OperatorService,
    OPERATOR_SERVICE_NAME,
} from '../../../../service/admin/OperatorService';
import { LoadingViewState } from '../../RouterView';
import { EntityDataTable } from '../../../list/EntityDataTable';
import { FormGroup } from '../../../form/FormGroup';
import { FormInput } from '../../../form/FormInput';
import { ColumnType } from '../../../list/ColumnType';
import { FormDateTimePicker } from '../../../form/FormDateTimePicker';
import { Modal } from 'react-bootstrap';
import { SimpleTable, ColumnDef } from '../../../util/SimpleTable';

interface State extends LoadingViewState {
    formInputClass?: string;
    listRequest?: HistoricTournamentListRequest;
    form?: HistoricTournamentListRequest;
    validationMap?: any;
    tournamentId?: string;
    tournamentTypeError?: boolean;
    tournamentToRefund?: HistoricTournament;
    calculatedTournamentRefundResponse?: CalculatedTournamentRefundResponse;
    tournamentRefundResponse?: TournamentRefundResponse;
}

const tournamentTypes: Array<{name: string, model: string}> = [
    {name: 'Scheduled Tournaments', model: 'scheduled'},
    {name: 'Sit And Go\'s', model: 'sitAndGo'},
    {name: 'Jackpot Sit And Go\'s', model: 'jackpotSitAndGo'},
];

const refundSummaryColumns: Array<ColumnDef<PlayerRefund>> = [
    { property: 'playerId', displayName: 'ID' },
    { property: 'screenName', displayName: 'Screen Name' },
    { property: 'amount', displayName: 'Amount' },
];

export class TournamentHistoryListView extends ListView<State, HistoricTournamentListRequest> implements FormListener<HistoricTournamentListRequest> {
    columns = [
        {property: 'id', name: 'ID', orderBy: 'ID'},
        {property: 'tournamentName', name: 'Name'},
        {property: 'tournamentId', name: 'Tournament Instance ID', orderBy: 'userName'},
        {property: 'status', name: 'Status'},
        {property: 'startTime', name: 'Scheduled Start Time', type: ColumnType.DATE},
    ];

    actions = [
        {id: 'view', name: 'View', className: 'btn btn-primary', iconClassName: 'fa fa-eye'},
    ];

    tournamentHistoryService: TournamentHistoryService;
    operatorService: OperatorService;

    constructor(props) {
        super(props, '/tournament-history');

        const utcNow = moment.utc().valueOf();
        const utcYesterday = moment().utc().subtract(1, 'days').valueOf();
        this.state = createInitialState({
            formInputClass: 'form-control',
            fromDate: utcYesterday,
            toDate: utcNow,
            scheduled: true,
            sitAndGo: false,
            jackpotSitAndGo: false,
            tournamentTypeError: false,
        } as ListRequest, this.state);

        this.tournamentHistoryService = kernel.get<TournamentHistoryService>(Symbols.TournamentHistoryService);
        this.operatorService = kernel.get<OperatorService>(OPERATOR_SERVICE_NAME);
    }

    formDidUpdate(form: HistoricTournamentListRequest, validationMap: any): void {
        const selectedTournamentTypes = TournamentHistoryListView.isTrueIgnoreTypeToInt(form.scheduled)
            + TournamentHistoryListView.isTrueIgnoreTypeToInt(form.sitAndGo)
            + TournamentHistoryListView.isTrueIgnoreTypeToInt(form.jackpotSitAndGo);

        this.setState({
            ...this.state,
            form,
            validationMap,
            tournamentTypeError: selectedTournamentTypes > 1,
        });
    }

    static isTrueIgnoreTypeToInt(input) {
        return (String(input) === 'true') ? 1 : 0;
    }

    onSubmitError(): void {
    }

    onSubmit(): void {
        const listRequest = Object.assign({}, this.state.listRequest, this.state.form);
        listRequest.offset = 0;
        listRequest.orderBy = 'ID';
        this.updateListState(listRequest);
    }

    onAction(item: HistoricTournament, action: string) {
        if (action === 'view') {
            this.navigate('/historic-tournament/' + item.id);
        } else if (action === 'refund') {
            if (item.status === 'CLOSED' || item.status === 'FINISHED') return;
            this.setState({
                tournamentToRefund: item,
            });
        }
    }

    getTitle() {
        return 'Tournament History';
    }

    showTournament() {
        const tournamentId = this.state.tournamentId;
        if (tournamentId.length > 0 && this.isValidId(tournamentId)) {
            this.navigate('/historic-tournament/' + this.state.tournamentId);
        }
    }

    isValidId(id : string){
        return id.match(/^[0-9a-fA-F]{24}$/);
    }

    handleChange(event: React.FormEvent) {
        const tournamentId = (event.target as any).value;
        let formInputClass = 'form-control';
        if(tournamentId.length > 0 && !this.isValidId(tournamentId)){
            formInputClass = formInputClass + ' error';
        }
        this.setState({ ...this.state, formInputClass, tournamentId });

    }

    openConfirmation = () => {
        this.setState({ });
    }

    closeModals = () => {
        this.setState({ });
    }

    getTournamentIdInputClass(){
        return this.state.formInputClass || 'form-control';
    }

    renderContent() {
        return (
            <div>
                <div className='row wrapper border-bottom white-bg page-heading'>
                    <div className='col-lg-12'>
                        <h1>{this.getTitle()}</h1>
                    </div>
                </div>

                <div className='wrapper wrapper-content'>
                    <div className='ibox float-e-margins'>
                        <div className='ibox-title'>
                            <h5>Find Tournament</h5>
                        </div>
                        <div className='ibox-content'>
                            <div className='form-horizontal row'>
                                <div className='form-group'>
                                    <label className='col-lg-2 control-label'>Tournament ID</label>
                                    <div className='col-lg-10'>
                                        <input type='text' className={this.getTournamentIdInputClass()}
                                               onChange={this.handleChange.bind(this)} value={this.state.tournamentId}/>
                                        <span
                                            className='help-block m-b-none'>The unique object id for a tournament</span>
                                    </div>
                                </div>
                                <div className='col-lg-offset-2 col-lg-10'>
                                    <input className='btn btn-primary' value='Show Tournament' type='submit'
                                           onClick={this.showTournament.bind(this)}/>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className='ibox float-e-margins'>
                        <div className='ibox-title'>
                            <h5>Filter Tournaments</h5>
                        </div>
                        <div className='ibox-content'>
                            <Form className='form-horizontal' formListener={this}
                                  modelObject={this.state.form} validationMap={this.state.validationMap}>

                                <FormGroup className='form-group' model='fromDate'>
                                    <label className='col-lg-2 control-label'>From Date (UTC):</label>
                                    <div className='col-lg-10'>
                                        <FormDateTimePicker timeZoneId={'UTC'} model='fromDate'/>
                                    </div>
                                </FormGroup>
                                <div className='hr-line-dashed'/>
                                <FormGroup className='form-group' model='toDate'>
                                    <label className='col-lg-2 control-label'>To Date (UTC):</label>
                                    <div className='col-lg-10'>
                                        <FormDateTimePicker timeZoneId={'UTC'} type='checkbox' model='toDate'/>
                                    </div>
                                </FormGroup>
                                <div className='hr-line-dashed'/>
                                <FormGroup className='form-group'>
                                    <label className='col-lg-2 control-label'>Tournament Type</label>
                                    <div className='col-lg-10'>
                                        {tournamentTypes.map((tournamentType, index) => {
                                            return (
                                                <div className='col-lg-10'  key={index}>
                                                    <FormInput className='col-lg-1' type='checkbox' name={tournamentType.model} model={tournamentType.model} />
                                                    <div className='col-lg-5'>{tournamentType.name}</div>
                                                </div>
                                            );
                                        })}
                                        <div className={`col-lg-10 alert alert-warning ${this.state.tournamentTypeError ? '' : 'hidden'}`}>
                                            Only one Tournament Type can be selected!
                                        </div>
                                    </div>
                                </FormGroup>
                                <div className='hr-line-dashed'/>
                                <FormGroup className='form-group' model='toDate'>
                                    <label className='col-lg-2 control-label'>Name:</label>
                                    <div className='col-lg-10'>
                                        <FormInput className='form-control' type='text' model='name'/>
                                    </div>
                                </FormGroup>
                                <div className='hr-line-dashed'/>
                                <div className='form-group'>
                                    <div className='col-lg-offset-2 col-lg-10'>
                                        <input className='btn btn-primary' value='Apply' type='submit'/>
                                    </div>
                                </div>
                            </Form>
                        </div>
                    </div>

                    <EntityDataTable service={this.tournamentHistoryService}
                                     onPagerChange={this.pagerChanged.bind(this)} columns={this.columns}
                                     listRequest={this.state.listRequest} onAction={this.onAction.bind(this)}
                                     actions={this.actions}/>
                </div>
            </div>
        );
    }

}



// WEBPACK FOOTER //
// ./src/app/ui/view/poker/history/TournamentHistoryListView.tsx